// Internationalization — English / 简体中文
export const translations = {
  en: {
    nav: { home: "Home", games: "Games", contact: "Contact", login: "Login", register: "Register" },
    common: {
      registerFree: "Register Free",
      loginNow: "Login Now",
      claimNow: "Claim Now",
      viewDetails: "View Details",
      joinNow: "Join Now",
      playNow: "Play Now",
      filter: "Filter",
      copy: "Copy",
      copied: "Phone number copied to clipboard",
    },
    brand: {
      tagline: "Malaysia's #1 Online Casino",
      subtitle: "Malaysia · Online Casino",
      tag2: "Malaysia · #1 Online Casino",
    },
    marquee: [
      "Welcome to U2 Gaming Malaysia — Best Online Casino!",
      "Register now & claim 200% Welcome Bonus!",
      "Login and play 500+ games from top providers!",
      "24/7 Live Chat Support via Telegram & WhatsApp!",
      "Fast withdrawals in 3 minutes — Maybank, CIMB, TnG & more!",
    ],
    hero: {
      tag: "Malaysia's #1 Online Casino",
      titleA: "U2 Gaming",
      titleB: "Best Online Casino",
      titleC: "Built for Malaysia",
      desc: "Slots · Live Casino · Sports Betting · Fishing — with",
      desc2: "30+ world-class providers",
      desc3: ". Register your U2 Gaming account today and win big.",
      stats: { games: "Games", providers: "Providers", withdraw: "Withdraw" },
      slides: [
        {
          eyebrow: "Welcome Bonus",
          title: "200% First Deposit Bonus",
          desc: "Claim your boost the moment you register your U2 Gaming account.",
          cta: "Register Now",
        },
        {
          eyebrow: "Live Casino",
          title: "Real Dealers · HD Stream",
          desc: "Baccarat · Roulette · Blackjack · Sicbo — 24/7 with real croupiers.",
          cta: "Play Live",
        },
        {
          eyebrow: "Sports & E-Sports",
          title: "Bet The World's Biggest Leagues",
          desc: "Football, basketball, esports & in-play live odds with U2 Gaming.",
          cta: "Bet Now",
        },
      ],
    },
    categories: {
      eyebrow: "U2 Gaming Library",
      title: "Pick Your Game",
      sub: "Hundreds of premium titles from 30+ world-class providers — handpicked for Malaysian players.",
      slots: { name: "Slots", desc: "500+ premium video slots from top providers worldwide" },
      live: { name: "Live Casino", desc: "HD-streamed Baccarat, Roulette & Blackjack — 24/7" },
      sports: { name: "Sports", desc: "Football, Basketball, eSports & in-play live odds" },
      fishing: { name: "Fishing", desc: "Action-packed fish shooter & arcade jackpots" },
    },
    promos: {
      eyebrow: "Promotions",
      title: "Exclusive U2 Bonuses",
      sub: "Welcome bonus, daily reload & weekly cashback — updated regularly for U2 Gaming members.",
      items: [
        {
          badge: "200%", badgeLabel: "Welcome Bonus", title: "New Member First Deposit",
          desc: "Register your U2 Gaming account today. Get up to 200% bonus on your first deposit — claimed instantly.",
          cta: "Claim Now",
        },
        {
          badge: "30%", badgeLabel: "Daily Bonus", title: "Daily Reload Bonus",
          desc: "Enjoy a 30% bonus every time you top up. The promo resets every 24 hours, more to play every single day.",
          cta: "View Details",
        },
        {
          badge: "10%", badgeLabel: "Weekly Cashback", title: "Weekly Cash Rebate",
          desc: "Win or lose, U2 gives back. Receive 10% cashback on weekly net losses — auto-credited every week.",
          cta: "Join Now",
        },
      ],
    },
    reasons: {
      eyebrow: "Why Choose Us",
      title: "Why Players Trust U2",
      sub: "6 reasons Malaysian players keep coming back to U2 Gaming.",
      items: [
        { icon: "ShieldCheck", title: "Safe & Secure", desc: "128-bit SSL encryption protects every transaction. Certified RNG for provably fair gameplay." },
        { icon: "Zap", title: "Instant Deposits", desc: "Maybank, CIMB, Public Bank, RHB, Hong Leong + TnG & Boost. Withdrawals in 3 minutes." },
        { icon: "Library", title: "Massive Library", desc: "30+ world-class providers — Pragmatic, Evolution, Playtech, JILI, JDB, Spade & more." },
        { icon: "Gift", title: "Generous Promos", desc: "Welcome bonus 200%, daily reloads, weekly cashback, referral rewards & VIP perks." },
        { icon: "Smartphone", title: "Mobile First", desc: "No download required. Optimized for every smartphone — iOS & Android browsers." },
        { icon: "Headphones", title: "24/7 Support", desc: "Bilingual support team online round-the-clock via Telegram & WhatsApp." },
      ],
    },
    faq: {
      eyebrow: "FAQ",
      title: "Frequently Asked",
      sub: "Everything you need to know about U2 Gaming.",
      items: [
        { q: "What is U2 Gaming?", a: "U2 Gaming is Malaysia's premier online casino platform offering slots, live casino, sports betting, and fishing games from top international providers. Built specifically for Malaysian players with full MYR support and 24/7 customer service." },
        { q: "How do I login to U2 Gaming?", a: "Click the Login button at the top right, enter your registered username and password, then sign in. Your U2 Gaming account is accessible instantly. Forgot password? Use the password reset option." },
        { q: "How do I register on U2 Gaming?", a: "Registering is quick and free. Click Register, fill in your basic details — username, password, mobile number — complete verification, and your account is ready in under 2 minutes." },
        { q: "Is U2 Gaming available in Malaysia?", a: "Yes — U2 Gaming is purpose-built for Malaysia. We support MYR transactions, all major Malaysian banking methods, and bilingual support in English & Mandarin." },
        { q: "What deposit & withdrawal methods do you support?", a: "All major Malaysian banks — Maybank, CIMB, Public Bank, RHB, Hong Leong — plus digital wallets such as Touch 'n Go, Boost & DuitNow QR. Fast, secure, hassle-free." },
        { q: "Is U2 Gaming safe and secure?", a: "Absolutely. We use 128-bit SSL encryption to protect every transaction. Our platform operates under a valid gaming license with certified RNG audits for fair play." },
      ],
    },
    cta: {
      eyebrow: "Ready to Start?",
      titleA: "Join Thousands of",
      titleB: "Winners",
      desc: "Create your U2 Gaming account in 2 minutes and claim your welcome bonus today.",
    },
    gamePage: {
      tag: "500+ Premium Titles",
      titleA: "U2 ",
      titleB: "Game Library",
      desc: "Slots · Live Casino · Sports · Fishing — handpicked from 30+ world-class providers including Pragmatic Play, Evolution, Playtech, JILI, JDB, Spade, Microgaming and more.",
      tabs: { all: "All Games", slots: "Slots", live: "Live Casino", sports: "Sports", fishing: "Fishing" },
      collageCaption: "Tap to play your favourite providers",
      empty: "No games for this filter — try another category.",
    },
    contactPage: {
      tag: "24/7 Support",
      titleA: "Contact ",
      titleB: "U2 Gaming",
      desc: "Reach our bilingual support team round-the-clock via Telegram or WhatsApp. Scan the QR codes below or tap to start a chat instantly.",
      whatsappEyebrow: "WhatsApp Chat",
      whatsappTitle: "Scan & Chat Instantly",
      whatsappDesc: "Open WhatsApp on your phone, tap the camera icon, and scan this QR code to start a private chat with our agent.",
      whatsappCta: "Open WhatsApp",
      telegramEyebrow: "Telegram Group",
      telegramTitle: "Join Our Official Group",
      telegramDesc: "Get instant updates on bonuses, events, jackpots & VIP perks. Join thousands of Malaysian players in our active Telegram community.",
      telegramCta: "Open Telegram",
      groupLink: "Group link",
      info: [
        { title: "Always Online", desc: "Our team is online 24 hours a day, 7 days a week — including weekends and holidays." },
        { title: "Private & Secure", desc: "Every message is encrypted. We never share your details with third parties." },
        { title: "Bilingual Support", desc: "Our agents are fluent in English and Mandarin — chat in the language you prefer." },
      ],
    },
    footer: {
      brandDesc: "U2 Gaming is Malaysia's premier online casino destination — slots, live casino, sports betting & fishing games from 30+ world-class providers. Licensed, secure & built for Malaysian players.",
      security: "128-bit SSL · Certified RNG · 24/7 Support",
      quickLinks: "Quick Links",
      reachUs: "Reach Us 24/7",
      payments: "Accepted Payments",
      paymentsSub: "Fast deposits & 3-minute withdrawals via all major Malaysian banks & e-wallets.",
      tgGroup: "Telegram Group",
      waChat: "WhatsApp Chat",
      copyright: "All rights reserved.",
      responsible: "Play Responsibly · 18+ Only",
    },
  },
  zh: {
    nav: { home: "首页", games: "游戏", contact: "联系我们", login: "登入", register: "注册" },
    common: {
      registerFree: "免费注册",
      loginNow: "立即登入",
      claimNow: "马上领取",
      viewDetails: "查看详情",
      joinNow: "立即加入",
      playNow: "立即开玩",
      filter: "筛选",
      copy: "复制",
      copied: "电话号码已复制",
    },
    brand: {
      tagline: "马来西亚 #1 网上娱乐城",
      subtitle: "马来西亚 · 网上娱乐城",
      tag2: "马来西亚 · #1 娱乐城",
    },
    marquee: [
      "欢迎来到 U2 Gaming 马来西亚 — 最佳网上娱乐城！",
      "立即注册，领取高达 200% 首存红利！",
      "登入畅玩 500+ 顶级供应商游戏！",
      "Telegram & WhatsApp 24/7 在线客服！",
      "3 分钟极速提款 — Maybank、CIMB、TnG 等！",
    ],
    hero: {
      tag: "马来西亚 #1 网上娱乐城",
      titleA: "U2 Gaming",
      titleB: "最佳网上娱乐城",
      titleC: "为大马而建",
      desc: "老虎机 · 真人娱乐 · 体育博彩 · 捕鱼 — 拥有",
      desc2: "30+ 世界顶级游戏供应商",
      desc3: "。立即注册 U2 Gaming，赢取大奖。",
      stats: { games: "游戏", providers: "供应商", withdraw: "提款" },
      slides: [
        { eyebrow: "新人红利", title: "200% 首存红利", desc: "注册 U2 Gaming 账户即刻领取超大首存优惠。", cta: "立即注册" },
        { eyebrow: "真人娱乐", title: "真人荷官 · 高清直播", desc: "百家乐 · 轮盘 · 21 点 · 骰宝 — 24 小时真人在线。", cta: "立即开玩" },
        { eyebrow: "体育 & 电竞", title: "全球顶级赛事任你下注", desc: "足球、篮球、电竞与即时滚球赔率，尽在 U2 Gaming。", cta: "立即下注" },
      ],
    },
    categories: {
      eyebrow: "U2 游戏大厅",
      title: "选择你的游戏",
      sub: "数百款精选游戏，来自 30+ 世界顶级供应商 — 专为大马玩家挑选。",
      slots: { name: "老虎机", desc: "500+ 顶级供应商精品视频老虎机" },
      live: { name: "真人娱乐", desc: "高清直播百家乐、轮盘与 21 点 — 全天候 24 小时" },
      sports: { name: "体育博彩", desc: "足球、篮球、电竞与即时滚球赔率" },
      fishing: { name: "捕鱼游戏", desc: "刺激射鱼游戏与街机大奖" },
    },
    promos: {
      eyebrow: "优惠活动",
      title: "U2 专属红利",
      sub: "新人红利、每日续存与每周返水 — 持续更新，专属 U2 Gaming 会员。",
      items: [
        { badge: "200%", badgeLabel: "新人红利", title: "新会员首存奖励", desc: "今日注册 U2 Gaming 账户。首存即享高达 200% 红利，即时入账。", cta: "马上领取" },
        { badge: "30%", badgeLabel: "每日红利", title: "每日续存红利", desc: "每次充值即可享 30% 红利。每 24 小时重置，让您天天有得玩。", cta: "查看详情" },
        { badge: "10%", badgeLabel: "每周返水", title: "每周亏损返水", desc: "无论输赢，U2 都给您回馈。每周净亏损 10% 自动返水。", cta: "立即加入" },
      ],
    },
    reasons: {
      eyebrow: "为何选择我们",
      title: "玩家为何信赖 U2",
      sub: "马来西亚玩家持续选择 U2 Gaming 的 6 大理由。",
      items: [
        { icon: "ShieldCheck", title: "安全可靠", desc: "128 位元 SSL 加密保护每笔交易。RNG 公平认证，玩得安心。" },
        { icon: "Zap", title: "极速存提款", desc: "Maybank、CIMB、Public Bank、RHB、Hong Leong + TnG & Boost — 3 分钟到账。" },
        { icon: "Library", title: "海量游戏", desc: "30+ 世界级供应商 — Pragmatic、Evolution、Playtech、JILI、JDB、Spade 等。" },
        { icon: "Gift", title: "丰厚优惠", desc: "200% 新人红利、每日续存、每周返水、推荐奖金与 VIP 礼遇。" },
        { icon: "Smartphone", title: "手机优先", desc: "无需下载。完美适配所有智能手机 — iOS 与 Android 浏览器。" },
        { icon: "Headphones", title: "24/7 客服", desc: "中英双语客服团队全天候在线 — Telegram 与 WhatsApp 即刻回应。" },
      ],
    },
    faq: {
      eyebrow: "常见问题",
      title: "常见疑问",
      sub: "您想了解的关于 U2 Gaming 的一切。",
      items: [
        { q: "什么是 U2 Gaming？", a: "U2 Gaming 是马来西亚顶尖的网上娱乐城平台，提供老虎机、真人娱乐、体育博彩与捕鱼游戏，全部来自顶级国际供应商。专为大马玩家打造，全面支持 MYR，提供 24/7 客服。" },
        { q: "如何登入 U2 Gaming？", a: "点击右上角「登入」按钮，输入您注册的用户名和密码，即可登入您的 U2 Gaming 账户。忘记密码？使用密码重置功能。" },
        { q: "如何注册 U2 Gaming？", a: "注册既简单又免费。点击「注册」，填写基本资料 — 用户名、密码、手机号码 — 完成验证，2 分钟内即可拥有账户。" },
        { q: "U2 Gaming 在马来西亚可用吗？", a: "是的 — U2 Gaming 专为马来西亚打造。我们支持 MYR 交易、所有马来西亚主流银行渠道，以及中英双语客服。" },
        { q: "支持哪些存款与提款方式？", a: "所有马来西亚主流银行 — Maybank、CIMB、Public Bank、RHB、Hong Leong — 以及电子钱包如 Touch 'n Go、Boost 与 DuitNow QR。快速、安全、无烦恼。" },
        { q: "U2 Gaming 安全吗？", a: "当然。我们使用 128 位元 SSL 加密保护每笔交易。平台拥有合法博彩牌照，RNG 经过认证审核，确保公平游戏。" },
      ],
    },
    cta: {
      eyebrow: "准备好了吗？",
      titleA: "加入数千名",
      titleB: "赢家行列",
      desc: "2 分钟即可创建您的 U2 Gaming 账户，今日领取新人红利。",
    },
    gamePage: {
      tag: "500+ 精品游戏",
      titleA: "U2 ",
      titleB: "游戏大厅",
      desc: "老虎机 · 真人娱乐 · 体育 · 捕鱼 — 来自 30+ 世界顶级供应商，包括 Pragmatic Play、Evolution、Playtech、JILI、JDB、Spade、Microgaming 等。",
      tabs: { all: "全部游戏", slots: "老虎机", live: "真人娱乐", sports: "体育", fishing: "捕鱼" },
      collageCaption: "点击立即畅玩您喜爱的供应商",
      empty: "此筛选下暂无游戏 — 请选择其他分类。",
    },
    contactPage: {
      tag: "24/7 客服",
      titleA: "联系 ",
      titleB: "U2 Gaming",
      desc: "通过 Telegram 或 WhatsApp 联系我们的中英双语客服团队。扫描下方二维码或点击立即开始聊天。",
      whatsappEyebrow: "WhatsApp 聊天",
      whatsappTitle: "扫码即刻聊天",
      whatsappDesc: "在手机上打开 WhatsApp，点击相机图标，扫描此二维码即可与客服私聊。",
      whatsappCta: "打开 WhatsApp",
      telegramEyebrow: "Telegram 群组",
      telegramTitle: "加入官方群组",
      telegramDesc: "即时获取红利、活动、大奖与 VIP 礼遇资讯。加入数千名大马玩家的 Telegram 活跃社群。",
      telegramCta: "打开 Telegram",
      groupLink: "群组链接",
      info: [
        { title: "全天在线", desc: "我们的团队全年 24 小时在线 — 包括周末与公共假期。" },
        { title: "私密安全", desc: "每条消息均加密传输。我们绝不与第三方分享您的资料。" },
        { title: "中英双语", desc: "客服流利掌握英语与中文 — 用您熟悉的语言畅聊。" },
      ],
    },
    footer: {
      brandDesc: "U2 Gaming 是马来西亚顶尖的网上娱乐城 — 提供老虎机、真人娱乐、体育博彩与捕鱼游戏，来自 30+ 世界级供应商。合法授权、安全可靠，专为大马玩家打造。",
      security: "128 位 SSL 加密 · RNG 认证 · 24/7 客服",
      quickLinks: "快速链接",
      reachUs: "24/7 联系我们",
      payments: "支持的付款方式",
      paymentsSub: "通过马来西亚所有主流银行与电子钱包，享受快速存款与 3 分钟提款。",
      tgGroup: "Telegram 群组",
      waChat: "WhatsApp 聊天",
      copyright: "版权所有。",
      responsible: "理性博彩 · 仅限 18 岁以上",
    },
  },
};
